module.exports = String.fromCharCode;